import {type ReactNode} from "react";
import {Box, Col, Row, Text} from "../../ui/Box";
import Button from "../../ui/Button";
import Icon from "../../ui/Icon";

type HeaderProps = {
  title?: ReactNode;
  titleComponent?: ReactNode;
  backButton?: {to: string; label: ReactNode};
  actions?: ReactNode;
};
const Header = (props: HeaderProps) => {
  const {title, titleComponent, backButton, actions} = props;
  return (
    <Col>
      <Box
        sp="8"
        display="grid"
        gridTemplateColumns="_header"
        surface
        py="8"
        px="12"
        elevation="200"
        align="center"
      >
        {backButton ? (
          <Row justify="start" align="center">
            <Button variant="tertiary" to={backButton.to}>
              <Icon name="chevron-left" inline /> {backButton.label}
            </Button>
          </Row>
        ) : (
          <div />
        )}
        {title ? (
          <Text
            bold
            as="h1"
            size="20"
            color="primary"
            textOverflow="ellipsis"
            overflow="hidden"
            textWrap="nowrap"
          >
            {title}
          </Text>
        ) : (
          titleComponent
        )}
        {actions ? (
          <Row justify="end" align="center" sp="8">
            {actions}
          </Row>
        ) : (
          <div />
        )}
      </Box>
    </Col>
  );
};

export default Header;
